export { default as ParallaxImage } from './ParallaxImage';
export { default as BannerBackgroundImage } from './BannerBackgroundImage';
